// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects'

import {
  getAllSalas as getAllSalasAPI,
  getUserChat as getUsuarioAPI,
  getAllUsersChat as getAllUsuariosAPI,
  getMessages as getMessagesAPI,
  getUsuariosInSala as getUsuariosInSalaAPI,
  addMessage as addMessageAPI,
  getNotifications as getNotificationsAPI,
  updatePinnedChats as updatePinnedAPI,
  updateNotifications as updateNotificationsAPI,
  missingMessages as missingMessagesAPI,
  deleteMessage as deleteMessageAPI,
  uploadFile as uploadFileAPI,
  downloadFile as downloadFileAPI,
  listFiles as listFilesAPI,
  createFolder as createFolderAPI,
  deleteFile as deleteFileAPI,
  listEventosCalendario as listEventosCalendarioAPI,
  createEventoCalendario as createEventoCalendarioAPI,
  updateEventoCalendario as updateEventoCalendarioAPI,
  deleteEventoCalendario as deleteEventoCalendarioAPI
} from '../../helpers/'

import { chatApiResponseError, chatApiResponseSuccess } from './actions'
import { ChatActionTypes } from './constants'

function * getUser ({ payload: { id } }) {
  try {
    const response = yield call(getUsuarioAPI, id)
    const user = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.GET_USUARIO, user))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.GET_USUARIO, error))
  }
}

function * listSalas ({ payload: { id } }) {
  try {
    const response = yield call(getAllSalasAPI, id)
    const lista = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.LIST_SALAS, lista))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.LIST_SALAS, error))
  }
}

function * listUsuarios ({ payload: { id } }) {
  try {
    const response = yield call(getAllUsuariosAPI, id)
    const lista = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.LIST_USUARIOS, lista))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.LIST_USUARIOS, error))
  }
}

function * listUsuariosInSala ({ payload: { id } }) {
  try {
    const response = yield call(getUsuariosInSalaAPI, id)
    const lista = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.LIST_USUARIOS_IN_SALA, lista))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.LIST_USUARIOS_IN_SALA, error))
  }
}

function * listMessages ({ payload: params }) {
  try {
    const response = yield call(getMessagesAPI, { ...params })
    const lista = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.LIST_MSG, lista))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.LIST_MSG, error))
  }
}

function * addMensaje ({ payload: mensaje }) {
  try {
    const response = yield call(addMessageAPI, { ...mensaje })
    const messageItem = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.ADD_MSG, messageItem))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.ADD_MSG, error))
  }
}

function * getNotis ({ payload: { id } }) {
  try {
    const response = yield call(getNotificationsAPI, id)
    const notis = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.GET_NOTIFICATIONS, notis))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.GET_NOTIFICATIONS, error))
  }
}

function * updatePinned ({ payload: data }) {
  try {
    const response = yield call(updatePinnedAPI, { ...data })
    const dataItem = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.UPDATE_PINNED, dataItem))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.UPDATE_PINNED, error))
  }
}

function * updateNotis ({ payload: data }) {
  try {
    const response = yield call(updateNotificationsAPI, { ...data })
    const dataItem = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.UPDATE_NOTIFICATIONS, dataItem))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.UPDATE_NOTIFICATIONS, error))
  }
}

function * getMissingMessages ({ payload: data }) {
  try {
    const response = yield call(missingMessagesAPI, { ...data })
    const dataItem = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.MISSING_MSG, dataItem))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.MISSING_MSG, error))
  }
}

function * deleteMessage ({ payload: data }) {
  try {
    const response = yield call(deleteMessageAPI, { ...data })
    const dataItem = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.DELETE_MSG, dataItem))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.DELETE_MSG, error))
  }
}

// Files manager
function * listFiles ({ payload: data }) {
  try {
    const response = yield call(listFilesAPI, { ...data })
    const dataItem = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.LIST_FILES, dataItem))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.LIST_FILES, error))
  }
}
function * downloadFile ({ payload: data }) {
  try {
    const response = yield call(downloadFileAPI, { ...data })
    const dataItem = response.data
    yield put(chatApiResponseSuccess(ChatActionTypes.DOWNLOAD_FILE, dataItem))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.DOWNLOAD_FILE, error))
  }
}
function * createFolder ({ payload: data }) {
  try {
    const response = yield call(createFolderAPI, { ...data })
    const dataItem = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.CREATE_FOLDER, dataItem))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.CREATE_FOLDER, error))
  }
}

function * deleteFile ({ payload: data }) {
  try {
    const response = yield call(deleteFileAPI, { ...data })
    const dataItem = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.DELETE_FILE, dataItem))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.DELETE_FILE, error))
  }
}

function * uploadFile ({ payload: data }) {
  try {
    const response = yield call(uploadFileAPI, { ...data })
    const dataItem = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.UPLOAD_FILE, dataItem))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.UPLOAD_FILE, error))
  }
}

// Calendar
function * listEventosCalendario ({ payload: { id } }) {
  try {
    const response = yield call(listEventosCalendarioAPI, id)
    const lista = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.LIST_EVENTOS_CALENDARIO, lista))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.LIST_EVENTOS_CALENDARIO, error))
  }
}

function * createEventoCalendario ({ payload: data }) {
  try {
    const response = yield call(createEventoCalendarioAPI, { ...data })
    const dataItem = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.CREATE_EVENTO_CALENDARIO, dataItem))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.CREATE_EVENTO_CALENDARIO, error))
  }
}

function * updateEventoCalendario ({ payload: data }) {
  try {
    const response = yield call(updateEventoCalendarioAPI, { ...data })
    const dataItem = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.UPDATE_EVENTO_CALENDARIO, dataItem))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.UPDATE_EVENTO_CALENDARIO, error))
  }
}

function * deleteEventoCalendario ({ payload: data }) {
  try {
    const response = yield call(deleteEventoCalendarioAPI, { ...data })
    const dataItem = response.data.data
    yield put(chatApiResponseSuccess(ChatActionTypes.DELETE_EVENTO_CALENDARIO, dataItem))
  } catch (error) {
    yield put(chatApiResponseError(ChatActionTypes.DELETE_EVENTO_CALENDARIO, error))
  }
}

export function * watchGetUser () {
  yield takeEvery(ChatActionTypes.GET_USUARIO, getUser)
}
export function * watchListSalas () {
  yield takeEvery(ChatActionTypes.LIST_SALAS, listSalas)
}
export function * watchListUsuarios () {
  yield takeEvery(ChatActionTypes.LIST_USUARIOS, listUsuarios)
}
export function * watchListUsuariosInSala () {
  yield takeEvery(ChatActionTypes.LIST_USUARIOS_IN_SALA, listUsuariosInSala)
}
export function * watchListMsg () {
  yield takeEvery(ChatActionTypes.LIST_MSG, listMessages)
}
export function * watchAddMsg () {
  yield takeEvery(ChatActionTypes.ADD_MSG, addMensaje)
}
export function * watchGetNotis () {
  yield takeEvery(ChatActionTypes.GET_NOTIFICATIONS, getNotis)
}
export function * watchUpdatePinned () {
  yield takeEvery(ChatActionTypes.UPDATE_PINNED, updatePinned)
}
export function * watchUpdateNotis () {
  yield takeEvery(ChatActionTypes.UPDATE_NOTIFICATIONS, updateNotis)
}
export function * watchMissingMsg () {
  yield takeEvery(ChatActionTypes.MISSING_MSG, getMissingMessages)
}
export function * watchDeleteMsg () {
  yield takeEvery(ChatActionTypes.DELETE_MSG, deleteMessage)
}
export function * watchListFiles () {
  yield takeEvery(ChatActionTypes.LIST_FILES, listFiles)
}
export function * watchDownloadFile () {
  yield takeEvery(ChatActionTypes.DOWNLOAD_FILE, downloadFile)
}
export function * watchCreateFolder () {
  yield takeEvery(ChatActionTypes.CREATE_FOLDER, createFolder)
}
export function * watchDeleteFile () {
  yield takeEvery(ChatActionTypes.DELETE_FILE, deleteFile)
}
export function * watchUploadFile () {
  yield takeEvery(ChatActionTypes.UPLOAD_FILE, uploadFile)
}
export function * watchListEventosCalendario () {
  yield takeEvery(ChatActionTypes.LIST_EVENTOS_CALENDARIO, listEventosCalendario)
}
export function * watchCreateEventoCalendario () {
  yield takeEvery(ChatActionTypes.CREATE_EVENTO_CALENDARIO, createEventoCalendario)
}
export function * watchUpdateEventoCalendario () {
  yield takeEvery(ChatActionTypes.UPDATE_EVENTO_CALENDARIO, updateEventoCalendario)
}
export function * watchDeleteEventoCalendario () {
  yield takeEvery(ChatActionTypes.DELETE_EVENTO_CALENDARIO, deleteEventoCalendario)
}

function * chatSaga () {
  yield all([
    fork(watchGetUser),
    fork(watchListSalas),
    fork(watchListUsuarios),
    fork(watchListMsg),
    fork(watchListUsuariosInSala),
    fork(watchAddMsg),
    fork(watchGetNotis),
    fork(watchUpdatePinned),
    fork(watchUpdateNotis),
    fork(watchMissingMsg),
    fork(watchDeleteMsg),
    fork(watchListFiles),
    fork(watchDownloadFile),
    fork(watchCreateFolder),
    fork(watchDeleteFile),
    fork(watchUploadFile),
    fork(watchListEventosCalendario),
    fork(watchCreateEventoCalendario),
    fork(watchUpdateEventoCalendario),
    fork(watchDeleteEventoCalendario)
  ])
}

export default chatSaga
